module.exports = __webpack_public_path__ + "img/wbtc-vault.18a82696.svg";